<script>
  import * as restfulService from '../../../../services/restfulService'
  import * as MESSAGES from '../../../../messages'

  import bus from '@utils/bus'
  import {mapActions} from 'vuex'

  import {email, requiredIf, minLength} from 'vuelidate/lib/validators'

  export default {
    props: ['show'],
    data () {
      return {
        botaoClicado: false,
        formaRecuperacao: 'matriculaEmail',
        emailDeRecuperacaoEnviado: false,
        emailCadastroNaoEncontrado: false,
        cpfRgCadastroNaoEncontrado: false,
        emailEnviado: '',
        matricula: '',
        email: '',
        cpf: '',
        rg: ''
      }
    },
    validations: {
      matricula: {
        required: requiredIf(function () {
          return !this.email
        })
      },
      email: {
        email,
        required: requiredIf(function () {
          return !this.matricula
        })
      },
      cpf: {
        required: requiredIf(function () {
          return !this.rg
        }),
        minLength: minLength(14)
      },
      rg: {
        required: requiredIf(function () {
          return !this.cpf
        })
      }
    },
    watch: {
      show: function (value, oldValue) {
        if (oldValue && !value) {
          this.$v.matricula.$reset()
          this.$v.email.$reset()
          this.$v.cpf.$reset()
          this.$v.rg.$reset()
          this.botaoClicado = false
          this.formaRecuperacao = 'matriculaEmail'
          this.emailDeRecuperacaoEnviado = false
          this.emailCadastroNaoEncontrado = false
          this.cpfRgCadastroNaoEncontrado = false
          this.emailEnviado = ''
          this.matricula = ''
          this.email = ''
          this.cpf = ''
          this.rg = ''
        }
      },
      formaRecuperacao: function () {
        this.$v.matricula.$reset()
        this.$v.email.$reset()
        this.$v.cpf.$reset()
        this.$v.rg.$reset()
        this.emailDeRecuperacaoEnviado = false
        this.emailCadastroNaoEncontrado = false
        this.cpfRgCadastroNaoEncontrado = false
      }
    },
    computed: {
      matriculaErros () {
        const erros = []
        if (!this.$v.matricula.$dirty) return erros
        !this.$v.matricula.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      emailErros () {
        const erros = []
        if (!this.$v.email.$dirty) return erros
        !this.$v.email.email && erros.push(MESSAGES.VALIDATION_EMAIL)
        !this.$v.email.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      cpfErros () {
        const erros = []
        if (!this.$v.cpf.$dirty) return erros
        !this.$v.cpf.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        !this.$v.cpf.minLength && erros.push('O campo CPF precisa no mínimo 11 números')
        return erros
      },
      rgErros () {
        const erros = []
        if (!this.$v.rg.$dirty) return erros
        !this.$v.rg.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      }
    },
    methods: {
      ...mapActions(['showNotification']),
      enviarRecuperacaoEmail () {
        bus.$emit('show-loader')
        this.botaoClicado = true
        let data = {
          matricula: this.matricula || null,
          email: this.email || null
        }
        restfulService.post('acesso', 'solicitar-recuperacao', null, data)
          .then(response => {
            bus.$emit('hide-loader')
            this.showNotification({message: 'Solicitação de recuperação realizada'})
            this.emailEnviado = response.email
            this.matricula = ''
            this.email = ''
            this.$v.matricula.$reset()
            this.$v.email.$reset()
            this.emailDeRecuperacaoEnviado = true
            this.botaoClicado = false
          })
          .catch(e => {
            bus.$emit('hide-loader')
            this.botaoClicado = false
            console.log(e)
          })
      },
      enviarRecuperacaoCpfRg () {
        bus.$emit('show-loader')
        this.botaoClicado = true
        let data = {
          cpf: this.cpf || null,
          rg: this.rg || null
        }
        restfulService.post('acesso', 'solicitar-recuperacao', null, data)
          .then(response => {
            bus.$emit('hide-loader')
            this.showNotification({message: 'Solicitação de recuperação realizada'})
            this.emailEnviado = response.email
            this.cpf = ''
            this.rg = ''
            this.$v.cpf.$reset()
            this.$v.rg.$reset()
            this.emailDeRecuperacaoEnviado = true
            this.botaoClicado = false
          })
          .catch(e => {
            bus.$emit('hide-loader')
            this.botaoClicado = false
            console.log(e)
          })
      },
      voltarLogin () {
        this.$emit('update:show', false)
        this.$router.push({name: 'login'})
        bus.$emit('hide-loader')
      }
    }
  }
</script>

<template>
    <div v-if="show">
        <v-card class="recuperacao-acesso">
            <v-card-title class="primary white--text"
                          >Recuperação de Acesso
            </v-card-title>
            <div class="card-conteudo">
                <h3>Selecione a forma de recuperação</h3>
                <v-radio-group v-model="formaRecuperacao" :mandatory="true">
                    <v-radio label="Informar Matrícula/Email" value="matriculaEmail" color="orange"/>
                    <v-radio label="Informar CPF/RG" value="cpfRg" color="orange"/>
                </v-radio-group>
                <div v-if="formaRecuperacao === 'matriculaEmail'" key="formEmail">
                    <v-container fluid grid-list-md>
                        <v-layout row wrap>
                            <v-flex sm6 xs12>
                                <v-text-field v-model="matricula"
                                              type="tel"
                                              :error-messages="matriculaErros"
                                              @input="$v.matricula.$touch()"
                                              @blur="$v.matricula.$touch()"
                                              @keyup.enter.native="enviarRecuperacaoEmail"
                                              label="Matrícula"/>
                            </v-flex>
                            <v-flex sm6 xs12>
                                <v-text-field v-model="email"
                                              :error-messages="emailErros"
                                              @input="$v.email.$touch()"
                                              @blur="$v.email.$touch()"
                                              @keyup.enter.native="enviarRecuperacaoEmail"
                                              label="Email"/>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-btn color="success"
                           @click="enviarRecuperacaoEmail"
                           :disabled="botaoClicado || $v.matricula.$invalid || $v.email.$invalid">
                        <i class="fas fa-check"></i>
                        <span class="pl-2">Enviar Email de Recuperação</span>
                    </v-btn>
                    <div v-if="emailDeRecuperacaoEnviado" class="email-enviado">
                        Enviamos um email para <strong>{{emailEnviado}}</strong>,
                        acesse o link enviado para completar o processo de recuperação.
                    </div>
                    <div v-if="emailDeRecuperacaoEnviado" class="email-enviado">
                        Caso você não tenha mais acesso a esse email, entre em contato conosco para realizar a alteração
                        do seu email principal.<br>
                        <strong>Central de Atendimento</strong><br>
                        <strong>Telefone:</strong> (53) 3242.8244 - Ramal 1090/1091/1092/1093<br>
                        <strong>Email:</strong> centraldeatendimento@urcamp.edu.br
                    </div>
                    <div v-if="emailCadastroNaoEncontrado" class="cadastro-naoencontrado">
                        Não conseguimos encontrar o cadastro do email <strong>{{this.email}}</strong>,
                        verifique o email digitado ou utilize as outras formas de recuperação.
                    </div>
                </div>
                <div v-if="formaRecuperacao === 'cpfRg'" key="formCpfRg">
                    <v-container fluid grid-list-md>
                        <v-layout row wrap>
                            <v-flex sm6 xs12>
                                <v-text-field v-model="cpf"
                                              type="tel"
                                              :error-messages="cpfErros"
                                              @input="$v.cpf.$touch()"
                                              @blur="$v.cpf.$touch()"
                                              v-mask="'###.###.###-##'"
                                              @keyup.enter.native="enviarRecuperacaoCpfRg"
                                              label="CPF"/>
                            </v-flex>
                            <v-flex sm6 xs12>
                                <v-text-field v-model="rg"
                                              :error-messages="rgErros"
                                              @input="$v.rg.$touch()"
                                              @blur="$v.rg.$touch()"
                                              @keyup.enter.native="enviarRecuperacaoCpfRg"
                                              label="Identidade"/>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-btn color="success"
                           @click="enviarRecuperacaoCpfRg"
                           :disabled="botaoClicado || $v.cpf.$invalid || $v.rg.$invalid">
                        <i class="fas fa-check"></i>
                        <span class="pl-2">Enviar Email de Recuperação</span>
                    </v-btn>
                    <div v-if="emailDeRecuperacaoEnviado" class="email-enviado">
                        Enviamos um email para <strong>{{emailEnviado}}</strong>,
                        acesse o link enviado para completar o processo de recuperação.
                    </div>
                    <div v-if="cpfRgCadastroNaoEncontrado" class="cadastro-naoencontrado">
                        Não conseguimos encontrar o cadastro com <strong>CPF ou RG</strong> que foram informados,
                        verifique os dados digitados ou utilize as outras formas de recuperação.
                    </div>
                </div>
            </div>
            <div class="voltar-login">
                <v-btn @click="voltarLogin">
                    <i class="fas fa-arrow-left"></i>
                    <span class="pl-2">Voltar para a tela de login</span>
                </v-btn>
            </div>
        </v-card>
    </div>
</template>

<style lang="scss">
    .recuperacao-acesso {
        min-width: 600px;
        max-width: 600px;
        .headline {
            justify-content: center;
            font-size: 20px !important;
        }
        .card-conteudo {
            padding: 20px 40px;
            h3 {
                font-size: 16px;
                font-weight: 400;
                color: #636363;
            }
            .container {
                padding: 15px 0 !important;
            }
        }

        .email-enviado,
        .cadastro-naoencontrado {
            border: 1px solid #ededed;
            border-radius: 4px;
            padding: 15px;
            margin-top: 25px;
            color: #6e6e6e;
            font-size: 14px;
        }
        .cadastro-naoencontrado {
            border-color: rgba(189, 65, 71, 0.32);
            color: #ff5252;
        }
        .voltar-login {
            text-align: center;
            padding-top: 5px;
            padding-bottom: 20px;
        }
    }

    @media all and (max-width: 768px) {
        .recuperacao-acesso {
            min-width: 90vw;
            max-width: none;
            .card-conteudo {
                padding: 15px 10px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// RecuperarSenha.vue?58e246a9